import * as dataLayerConstants from '../../../analytics/src/datalayer/constants';
import getLinkWithTargetPath from '../helpers/append-target-path';

export const headerButtonLoaded = messageParts => {
	const headerButtonData = JSON.parse( messageParts[ 1 ] );

	const headerButtonLinks = document.querySelectorAll( '[data-sub-link=nsheader]' );

	headerButtonLinks.forEach( link => {
		const pianoSublink = headerButtonData.link;
		const linkWithTargetPath = getLinkWithTargetPath( pianoSublink );
		link.href = linkWithTargetPath.href;

		const event = {
			event: 'button',
			event_action: 'click',
			event_type: 'subscribe',
			event_object_name: 'subscribe button',
			event_object_text: `${headerButtonData.copy}`,
			event_label: headerButtonData?.gaLabel ?? '',
			piano_label: headerButtonData?.gaLabel ?? '',
			service_platform: dataLayerConstants.SERVICE_PLATFORM_PIANO,
			template_id: headerButtonData?.templateId ?? '',
			offer_id: headerButtonData?.offerId ?? '',
			term_id: headerButtonData?.termId ?? '',
			experience_id: headerButtonData?.experienceId ?? '',
			variant_id: headerButtonData?.templateVariantId ?? '',
		};

		const headerButtonCopy = link.querySelector( 'span' );
		headerButtonCopy.innerText = headerButtonData.copy;

		link.addEventListener( 'click', () => {
			dataLayer.push( event );
		} );
	} );

	const buttonIdentifier = `buttonImpression1`;
	const buttonImpressionObject = {};
	buttonImpressionObject.event = buttonIdentifier;
	buttonImpressionObject[ `event_action_${buttonIdentifier}` ] = 'impression';
	buttonImpressionObject[ `event_type_${buttonIdentifier}` ] = 'subscribe';
	buttonImpressionObject[ `event_object_name_${buttonIdentifier}` ] = 'subscribe button';
	buttonImpressionObject[ `event_object_text_${buttonIdentifier}` ] = `${headerButtonData.copy}`;
	buttonImpressionObject[ `event_label_${buttonIdentifier}` ] = headerButtonData?.gaLabel ?? '';
	buttonImpressionObject[ `piano_label_${buttonIdentifier}` ] = headerButtonData?.gaLabel ?? '';
	buttonImpressionObject[ `service_platform_${buttonIdentifier}` ] = dataLayerConstants.SERVICE_PLATFORM_PIANO;
	buttonImpressionObject[ `template_id_${buttonIdentifier}` ] = headerButtonData?.templateId ?? '';
	buttonImpressionObject[ `offer_id_${buttonIdentifier}` ] = headerButtonData?.offerId ?? '';
	buttonImpressionObject[ `term_id_${buttonIdentifier}` ] = headerButtonData?.termId ?? '';
	buttonImpressionObject[ `experience_id_${buttonIdentifier}` ] = headerButtonData?.experienceId ?? '';
	buttonImpressionObject[ `variant_id_${buttonIdentifier}` ] = headerButtonData?.templateVariantId ?? '';

	if ( dataLayer ) {
		dataLayer.push( buttonImpressionObject );
	}
};

export default headerButtonLoaded;
